import React, { Component } from 'react';
import styles from './EditProfile.module.css';
import axios from 'axios';
import loader from '../../../assets/loader2.svg';
import {connect} from 'react-redux';

class EditProfile extends Component {
    state = {
        user: {},
        error: '',
        isSubmitting: false
    }

    componentDidMount() {
        document.getElementsByTagName('body')[0].style.overflow = 'hidden';

        axios.get('/users/' + this.props.loginStatus.userId 
        + '.json?auth='+ this.props.loginStatus.authToken)
        .then(response=>{
            this.setState({user: response.data});
        })
    }

    componentWillUnmount() {
        document.getElementsByTagName('body')[0].style.overflow = '';
    }
    
    inputOnChange = (event, key) => {
        const user = { ...this.state.user};
        user[key] = event.target.value;
        if(key === 'isAccountPrivate')  user[key] = event.target.checked;
        this.setState({user: user })
    }

    submit = (event) => {
        if(this.state.user.name.trim().length < 3) {
            this.setState({error: 'Name should be atleast 3 character'});
            return;
        }
        event.target.disabled = true;
        event.target.previousElementSibling.disabled = true;
        const bio = this.state.user.bio.trim() === '' ? 'NA' : this.state.user.bio;
        const user = { ...this.state.user};
        user.bio = bio;
        this.setState({user: user, error: '',isSubmitting:true});

        setTimeout(() => {
        axios.put('/users/' + this.props.loginStatus.userId 
        + '.json?auth='+ this.props.loginStatus.authToken, this.state.user)
        .then(response=>{
            this.props.close();
        })
        }, 500);
    }
    render() {
        return (
          <div className={styles.main}>
            <div className={styles.modal}>
              <div className={styles.header}>Edit Profile</div>
              {Object.keys(this.state.user).length === 0 ?
                <div style={{margin:'auto',marginTop:'35%'}}>
                    <img src={loader} alt="loading" width="30" height="30"/>
                </div> 
                :
                <div className={styles.body}>
                <div className={styles.profilePic}>
                    <img src={this.state.user.profilePic} alt="profile pic" />
                    {this.state.error !== '' ?
                        <div style={{color:'red'}}>{this.state.error}</div> : null
                    }
                </div>
                <div>
                    <label className={styles.formLabel}>Name</label>&nbsp;
                    <input type="text" className={styles.formInput} value={this.state.user.name} 
                    onChange={(event)=>this.inputOnChange(event, 'name')} maxLength="20"/>
                </div>
                <div>
                    <label className={styles.formLabel}>Bio</label>&nbsp;
                    <textarea  className={styles.formTextArea} value={this.state.user.bio} maxLength="150"
                    onChange={(event)=>this.inputOnChange(event, 'bio')}></textarea>
                </div>
                <div>
                    <label className={[styles.formLabel, styles.private].join(' ')}>Private Account</label>&nbsp;
                    <input type="checkbox" checked={this.state.user.isAccountPrivate}
                    onChange={(event)=>this.inputOnChange(event, 'isAccountPrivate')}/>
                </div>
                <div className={styles.footer}>
                     <button className={[styles.cancelBtn, styles.loginBtn].join(' ')} 
                     onClick={this.props.close}>Cancel</button>
                    <button className={styles.loginBtn} onClick={(event)=>this.submit(event)}>
                       {this.state.isSubmitting? <img src={loader} width="18" alt="loader" /> : 'Save'}
                    </button>
                </div>
            </div>
              } 
            </div>
          </div>
        )
    }
}

const mapStateToProps = state => {
    return {
        loginStatus: state.loginStatus
    }
}
export default connect(mapStateToProps)(EditProfile);